module.exports = __webpack_public_path__ + "static/media/portfolio 7.153b578a.JPG";